import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bendix-data-extraction-disclaimer',
  templateUrl: './bendix-data-extraction-disclaimer.component.html',
  styleUrl: './bendix-data-extraction-disclaimer.component.scss',
  standalone: false
})
export class BendixDataExtractionDisclaimerComponent {

  private dialogRef = inject(MatDialogRef<BendixDataExtractionDisclaimerComponent>)

  accept() {
    this.dialogRef.close(true);
  }
  closeButton() {
    this.dialogRef.close(false);
  }
}
